import { MIS_COLLECTION_REPORT, MIS_COLLECTION_REPORT_TITLE } from '../../Constants/strings';
import './CollectionReport.scss';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { DASHBOARD_COLLECTIONS } from '../../Api/resources/endPoint';
import {
  appendServiceNameToURL,
  appendServicePortToURL,
} from '../../Api/resources/serviceURLs';
import { serviceName } from '../../Api/resources/serviceConstants';
import TotalReceivable from './TotalReceivable/TotalReceivable';
import { CollectionReportProvider } from '../../Contexts/CollectionReportContext';
import BreakupCollectionPending from './BreakupCollectionPending/BreakupCollectionPending';
import CollectionDSO from './CollectionDSO/CollectionDSO';
import { IconButton, Tooltip } from '@mui/material';
import expandAllIcon from '../../Assets/images/svg/dar_collection_dashboard_expand_all.svg';
import collapseAllIcon from '../../Assets/images/svg/dar_collection_dashboard_collapse_all.svg';
import downloadIcon from '../../Assets/images/svg/dar_collection_dashboard_download.svg';
import AccordionWrapper from '../../Components/AccordionWrapper/AccordionWrapper';
import { useCollectionReport } from '../../Hooks/useCollectionReport';
import BadDeptReport from './BadDebt/BadDeptReport';
import AgingReceivableTable from './AgingOfAccountsReceivable/AgingReceivableTable';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { useSnackbar } from '../../Components/Snackbar/snackBarProvider';
import CollectionProjection from './CollectionProjection/CollectionProjection';
import CollectionEffectivenessIndex from './CollectionEffectivenessIndex/CollectionEffectivenessIndex';

const fetchBaseURL = async () => {
  const serviceURL = await appendServiceNameToURL(serviceName.PROJECT_MS); // NOSONAR
  const servicePort = await appendServicePortToURL(serviceName.PROJECT_MS); // NOSONAR
  if (process.env.NODE_ENV === 'production') {
    return (
      process.env.REACT_APP_API_URL
      + serviceURL
      + '/api'
      + DASHBOARD_COLLECTIONS
    );
  } else {
    return (
      process.env.REACT_APP_API_URL
      + `:${servicePort}`
      + serviceURL
      + '/api'
      + DASHBOARD_COLLECTIONS
    );
  }
};

const baseURL = await fetchBaseURL();

const CollectionReport = () => {
  const { accordionState, expandIndividual, createDownloadAllHandler } = useCollectionReport();
  const accordionConfiguration = {
    [MIS_COLLECTION_REPORT.DSO]: {
      title: MIS_COLLECTION_REPORT.DSO,
      state: accordionState[MIS_COLLECTION_REPORT.DSO],
      data: <CollectionDSO />,
      openHandler: () => expandIndividual(MIS_COLLECTION_REPORT.DSO),
    },
    [MIS_COLLECTION_REPORT.TOTAL_RECEIVABLE]: {
      title: MIS_COLLECTION_REPORT.TOTAL_RECEIVABLE,
      data: (
        <TotalReceivable
          baseURL={baseURL}
          createDownloadAllHandler={createDownloadAllHandler}
        />
      ),
      state: accordionState[MIS_COLLECTION_REPORT.TOTAL_RECEIVABLE],
      openHandler: () =>
        expandIndividual(MIS_COLLECTION_REPORT.TOTAL_RECEIVABLE),
    },
    [MIS_COLLECTION_REPORT.COLLECTION_PROJECTION]: {
      title: MIS_COLLECTION_REPORT.COLLECTION_PROJECTION,
      data: <CollectionProjection baseURL={baseURL}
        createDownloadAllHandler={createDownloadAllHandler} />,
      state: accordionState[MIS_COLLECTION_REPORT.COLLECTION_PROJECTION],
      openHandler: () =>
        expandIndividual(MIS_COLLECTION_REPORT.COLLECTION_PROJECTION),
    },
    [MIS_COLLECTION_REPORT.BREAKUP_COLLECTION_PENDING]: {
      title: MIS_COLLECTION_REPORT.BREAKUP_COLLECTION_PENDING,
      data: (
        <BreakupCollectionPending
          baseURL={baseURL}
          createDownloadAllHandler={createDownloadAllHandler}
        />
      ),
      state: accordionState[MIS_COLLECTION_REPORT.BREAKUP_COLLECTION_PENDING],
      openHandler: () =>
        expandIndividual(MIS_COLLECTION_REPORT.BREAKUP_COLLECTION_PENDING),
    },
    [MIS_COLLECTION_REPORT.AGING_ACCOUNTS_RECEIVABLE]: {
      title: MIS_COLLECTION_REPORT.AGING_ACCOUNTS_RECEIVABLE,
      data: (
        <AgingReceivableTable
          baseURL={baseURL}
          createDownloadAllHandler={createDownloadAllHandler}
        />
      ),
      state: accordionState[MIS_COLLECTION_REPORT.AGING_ACCOUNTS_RECEIVABLE],
      openHandler: () =>
        expandIndividual(MIS_COLLECTION_REPORT.AGING_ACCOUNTS_RECEIVABLE),
    },
    [MIS_COLLECTION_REPORT.COLLECTION_EFFECTIVENESS_INDEX]: {
      title: MIS_COLLECTION_REPORT.COLLECTION_EFFECTIVENESS_INDEX,
      data: (
        <CollectionEffectivenessIndex
          baseURL={baseURL}
          createDownloadAllHandler={createDownloadAllHandler}
        />
      ),
      state: accordionState[MIS_COLLECTION_REPORT.COLLECTION_EFFECTIVENESS_INDEX],
      openHandler: () =>
        expandIndividual(MIS_COLLECTION_REPORT.COLLECTION_EFFECTIVENESS_INDEX),
    },
    [MIS_COLLECTION_REPORT.BAD_DEBT_RATIO]: {
      title: MIS_COLLECTION_REPORT.BAD_DEBT_RATIO,
      data: (
        <BadDeptReport
          baseURL={baseURL}
          createDownloadAllHandler={createDownloadAllHandler}
        />
      ),
      state: accordionState[MIS_COLLECTION_REPORT.BAD_DEBT_RATIO],
      openHandler: () => expandIndividual(MIS_COLLECTION_REPORT.BAD_DEBT_RATIO),
    },
  };
  return (
    <div className="collection-dashboard-outer-layer">
      <div className="collection-dashboard">
        <UtilityBar />
        <AccordionWrapper
          backgroundColor={'#F1F5F8'}
          configuration={accordionConfiguration}
          titleClassname={'collection-report-table-titles'}
          accordionClassname={'collection-report-default'}
        />
      </div>
    </div>
  );
};

const UtilityBar = () => {
  const {
    expandAllHandler,
    allExpanded,
    downloadHandlers,
    onDownloadAllClick,
    downloadAllLoading,
  } = useCollectionReport();
  const [anchorEl, setAnchorEl] = useState(null);
  const { snackbarOpen } = useSnackbar();
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const downloadAllFunction = async () => {
    try {
      await onDownloadAllClick();
      snackbarOpen(
        'Reports download complete',
        'success',
      );
    } catch (error) {
      snackbarOpen(
        'Reports download failed',
        'error',
      );
    }
  };
  return (
    <div className="collection-dashboard-utility-bar">
      <h1 className="collection-dashboard-title">
        {MIS_COLLECTION_REPORT_TITLE}
      </h1>
      <div className="collection-dashboard-utility-btns">
        <Tooltip title={`${allExpanded ? 'Collapse all' : 'Expand all'}`}>
          <IconButton
            id="expand-collapse-btn"
            className="collection-dashboard-utility-btn"
            onClick={expandAllHandler}
          >
            <img
              src={allExpanded ? collapseAllIcon : expandAllIcon}
              alt={`${allExpanded ? 'Collapse all' : 'Expand all'}`}
            />
          </IconButton>
        </Tooltip>
        <Tooltip title={'Download'}>
          <IconButton
            id="export-to-excel-btn"
            className="collection-dashboard-utility-btn"
            onClick={handleClick}
          >
            <img src={downloadIcon} alt={'Download button'} />
          </IconButton>
        </Tooltip>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          disableScrollLock={true}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          sx={{
            mt: '8px',
          }}
        >
          <MenuItem
            sx={{
              display: 'flex',
              justifyContent: 'start',
              alignItems: 'center',
              gap: '8px',
            }}
            onClick={downloadAllFunction}
          >
            Download all {downloadAllLoading && <CircularProgress size={15} />}
          </MenuItem>
          {Object.values(downloadHandlers.current).map((obj) => {
            const downloadFunction = async () => {
              try {
                if (!obj.handler){
                  throw new Error();
                }
                await obj.handler();
                snackbarOpen(
                  obj.name + ' export complete',
                  'success',
                );
              } catch (error) {
                snackbarOpen(
                  obj.name + ' export failed',
                  'error',
                );
              }
            };
            return (
              <MenuItem
                key={obj.name}
                id={`${obj.name}-export-to-excel`}
                onClick={downloadFunction}
              >
                {obj.name}
              </MenuItem>
            );
          })}
        </Menu>
      </div>
    </div>
  );
};

const MainCollectionReport = () => (
  <CollectionReportProvider>
    <CollectionReport />
  </CollectionReportProvider>
);

export default MainCollectionReport;
